import React from "react";
import {Stack} from "@mui/joy";
import Chip from "@mui/joy/Chip";
import {customRange} from "../../utils/misc";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import Input from "@mui/joy/Input";


class Pagination extends React.Component{
    async processForm(event) {
        event.preventDefault();
        let formData = new FormData(event.currentTarget);
        this.props.onClick(formData.get('pageNumber'))
    }

    render() {
        return(
            <Stack
                direction={'row'}
                spacing={1}
                useFlexGap
                sx={{
                    alignItems: "center",
                    flexWrap: 'wrap',
                }}
            >
                {customRange(1, this.props.count, 1).map(
                    (p) => {
                        if (
                            [1, this.props.page - 1, this.props.page, this.props.page + 1, this.props.count].includes(p)
                        ){
                            return(
                                <>
                                    {
                                        p === this.props.page - 1 && !([1, 2].includes(p))?
                                            <Typography>...</Typography>:
                                            null
                                    }
                                    <Chip
                                        onClick={() => (this.props.onClick(p))}
                                        color={this.props.page === p?'primary':'neutral'}
                                        size={'sm'}
                                    >
                                        {p}
                                    </Chip>
                                    {
                                        p === this.props.page + 1 && !([this.props.count - 1, this.props.count].includes(p))?
                                            <Typography>...</Typography>:
                                            null
                                    }
                                </>
                            )
                        }
                        else {
                            return null
                        }
                    }
                )}
                <form
                    onSubmit={this.processForm.bind(this)}
                >
                    <Stack
                        direction={'row'}
                        spacing={1}
                    >
                        <Input
                            name={'pageNumber'}
                            type={'number'}
                            defaultValue={this.props.page}
                            size={'sm'}
                        />
                        <Button
                            size={'sm'}
                            type={'submit'}
                        >
                            Перейти
                        </Button>
                    </Stack>
                </form>
            </Stack>
        )
    }
}

export default Pagination